import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { environment } from '../../environments/environment';
import { ElasticSearchService } from '../_services/elastic-search.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.css']
})
export class ListItemComponent implements OnInit {
  @Input() type: string;
  @Output() array = new EventEmitter();
  storagePath: string;
  searchTerm: string;
  sub: Subscription = new Subscription();
  hits: any[];
  from = 0;
  size = 5;
  items: any[];
  constructor(
    private elasticSearchService: ElasticSearchService,
    private route: ActivatedRoute
  ) {
    this.storagePath = environment.storagePath;
  }

  ngOnInit() {
    this.load(this.size);
  }

  loadMore() {
    this.size += 10;
    this.load(this.size);
  }
  load(size) {
    this.sub = this.route.queryParams.subscribe(params => {
      this.searchTerm = params["searchTerm"];
      this.sub=this.loadSuggestions(this.size + 1).subscribe(result => {
        this.items = result;
        this.array.emit(this.items);
      })
    })
  }
  loadSuggestions(size) {
    let searchTerm = this.searchTerm.replace(/\s/g, '').replace(/@/g, '').replace(/,/g, '').replace(/'/g, '').replace(/\./g, '').toLowerCase().trim();
    return this.elasticSearchService.searchBy("SearchTermAndType", { searchTerm: searchTerm, types: [this.type], size: size });
  }
  ngOnDestroy() {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    try {
      this.sub.unsubscribe();
    } catch (e) { }
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/list-item/list-item.component.ts